<div class="my-dropdown-status {{size}}" (clickOutside)="isDropdownStatusOpen = false">
  <button (click)="isDropdownStatusOpen = !isDropdownStatusOpen" class="my-dropdown-status__button"><span class="circle color-{{ value }}"></span> {{ STATUS[value]?.label ? STATUS[value]?.label : "Status" }}</button>
  <ul *ngIf="isDropdownStatusOpen" class="my-dropdown-status__list">
    <li *ngFor="let status of STATUS" class="item" (click)="select(status.value)" [class.selected]="value == status.value"><span class="circle color-{{ status.value }}"></span> {{ status.label }}</li>
  </ul>
</div>
